if (typeof WishList !== 'function') {
  class WishList extends HTMLElement {
    constructor() {
      super()
      this.elements = {
        count: this.querySelector('[data-count]'),
        container: this.querySelector('[data-container]'),
        grid: this.querySelector('[data-grid]'),
        empty: this.querySelector('[data-empty]'),
        loader: this.querySelector('[data-loader]')
      }
      this.locales = window.KROWN.settings.locales
    }

    connectedCallback() {
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = []
      }
      window.SwymCallbacks.push(this.init.bind(this))
    }

    init(swatInstance) {
      this.swat = swatInstance
      this.fetchWishlist()
    }

    fetchWishlist() {
      this.showLoader()
      this.swat.fetchLists({
        callbackFn: (lists) => {
          const selectedList = lists?.[lists.length - 1]
          this.swat.swymCustomWishlistSelectedListId = selectedList?.lid
          this.renderList(selectedList?.listcontents ?? [])
        },
        errorFn: (error) => console.error('Error while fetching all Lists', error),
      })
    }

    async renderList(list) {
      if (!this.elements.grid || !this.elements.loader) return
      this.elements.grid.innerHTML = ''
      if (list.length > 0) {
        const wishlistedProducts = await this.fetchProductData(list)
        this.renderWishlist(wishlistedProducts)
      }
      this.updateUIState(list)
    }

    async fetchProductData(wishlist) {
      const productDataPromises = wishlist.map(async (listItem) => {
        const du = listItem.du?.split('?')[0] || ''
        const handle = du.replace(/\/+$/, '').split('/').pop()
        if (!handle) return listItem
        const root = window.Shopify.routes.root || '/'
        const productUrl = new URL(`${root}products/${handle}`, window.location.origin)
        productUrl.searchParams.set('view', 'item')

        const response = await fetch(productUrl)

        const text = await response.text()
        const doc = new DOMParser().parseFromString(text, 'text/html')

        // prend le bloc produit, pas toute la page
        const node =
          doc.querySelector('product-item.product-item') ||
          doc.querySelector('.product-item')

        listItem.template = node ? node.outerHTML : ''
        return listItem
      })
      return await Promise.all(productDataPromises)
    }

    renderWishlist(items = []) {
      const html = items.map(item => item.template).join('')
      const count = items.length === 1
        ? this.locales.wish_list_product_count_one
        : this.locales.wish_list_product_count_other
      this.elements.count.textContent = count.replace('[count]', items.length)
      this.elements.grid.innerHTML = html
      this.swat.initializeActionButtons('wish-list')
    }

    updateUIState(wishlist) {
      this.hideLoader()
      if (wishlist.length > 0) {
        this.elements.count.classList.remove('hide')
        this.elements.container.classList.remove('hide')
        this.elements.empty.classList.add('hide')
      } else {
        this.elements.count.classList.add('hide')
        this.elements.empty.classList.remove('hide')
        this.elements.container.classList.add('hide')
      }
    }

    showLoader() {
      this.elements.loader.classList.remove('hide')
    }

    hideLoader() {
      this.elements.loader.classList.add('hide')
    }
  }

  if (typeof customElements.get('wish-list') == 'undefined') {
    customElements.define('wish-list', WishList)
  }
}
